import PageHeader from "components/PageHeader";

const products = [
  {
    title: "Bird Watching Guide",
    description: "Complete guide to local bird species",
    price: "$24.99",
  },
  {
    title: "Mysher Aviary T-Shirt",
    description: "Premium cotton with logo design",
    price: "$19.99",
  },
  {
    title: "Bird Feeder Set",
    description: "Professional grade bird feeding kit",
    price: "$39.99",
  },
];

const giftFeatures = [
  {
    title: "Educational Materials",
    description:
      "Books, guides, and learning resources for bird enthusiasts of all ages.",
  },
  {
    title: "Unique Gifts",
    description:
      "Handcrafted items and exclusive Mysher Aviary branded merchandise.",
  },
  {
    title: "Support Conservation",
    description: "Your purchases help support our bird conservation efforts.",
  },
];

const Store = () => {
  return (
    <div className="min-h-screen pt-0">
      <PageHeader
        title="Store"
        subtitle="Shop our collection of bird-themed merchandise and gifts"
      />

      <div className="bg-white py-20 max-[768px]:py-[60px]">
        <div className="container">
          <div className="grid grid-cols-2 items-start gap-16 max-[968px]:grid-cols-1 max-[968px]:gap-8">
            <div className="mb-12">
              <h2 className="mb-8 text-4xl font-bold text-primary-blue max-[768px]:text-3xl">
                Featured Products
              </h2>
              <div className="mt-8 grid grid-cols-[repeat(auto-fit,minmax(250px,1fr))] gap-8">
                {products.map((product) => (
                  <div
                    key={product.title}
                    className="overflow-hidden rounded-xl bg-white shadow-[0_4px_15px_rgba(0,0,0,0.1)] transition-transform duration-300 hover:-translate-y-1.5"
                  >
                    <div className="flex h-[180px] items-center justify-center bg-gradient-to-br from-accent-green to-light-green text-5xl text-white" />
                    <h3 className="px-6 pb-2 pt-4 font-semibold text-primary-blue">
                      {product.title}
                    </h3>
                    <p className="mb-4 px-6 text-[0.95rem] text-text-light">
                      {product.description}
                    </p>
                    <span className="block px-6 pb-6 text-xl font-bold text-accent-green">
                      {product.price}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-12">
              <h2 className="mb-8 text-4xl font-bold text-primary-blue max-[768px]:text-3xl">
                Gift Shop
              </h2>
              <p className="mb-8 text-lg leading-[1.7] text-text-light">
                Take home a piece of your Mysher Aviary experience with our
                curated collection of bird-themed gifts, educational
                materials, and exclusive merchandise.
              </p>

              <div className="mt-8">
                {giftFeatures.map((feature, index) => (
                  <div
                    key={feature.title}
                    className={`mb-8 border-b border-[#e9ecef] pb-8 ${
                      index === giftFeatures.length - 1
                        ? "mb-0 border-b-0"
                        : ""
                    }`}
                  >
                    <h3 className="mb-2 font-semibold text-primary-blue">
                      {feature.title}
                    </h3>
                    <p className="mb-0 text-text-light">
                      {feature.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Store;
